module.exports = __webpack_public_path__ + "static/img/newHuaiC2.8b20f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/newHuaiC2.png
// module id = s+k5
// module chunks = 0